import { config } from "./config";
import 'isomorphic-fetch';

const apiOrigin = config.URL_API;

const publicOptions = (method, data) => {
  let opt = {
    method,
    headers: {
      'Content-Type': 'application/json',
    }
  };
  if (data) {
    opt.body = JSON.stringify(data);
  }
  return opt;
};


export const api = {

  consultas: {
    async send(data) {
      const response = await fetch(apiOrigin + '/email/consulta', publicOptions('POST', data));
      const res = await response.json();
      return res
    },
  },

};
